export const LANDING_PAGE_ANIMATION_DURATION_SECONDS = 0.6;
export enum ScreenDepthLanding {
  /*keep the order*/
  MAIN_CONTAINER = 0,
  HIDDEN_INPUTS = -1,
  ANIMATION_CONTAINER = 23,
}

export const WESTNEGEV_AGE_GROUPS = [
  "עד 18",
  "19-21",
  "22-27",
  "28-35",
  "36-45",
  "46-55",
  "56-65",
  "66-75",
  "75+",
] as const;

export type WestNegevAgeGroup = (typeof WESTNEGEV_AGE_GROUPS)[number];
